import { makeStyles } from 'tss-react/mui'
import { Button } from '@labrav/react-components'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { useSelector } from '../../store'

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(4, 3, 9, 3),
    margin: theme.spacing(4, 4, 0, 0),
    textAlign: 'justify',
  },
  button: {
    float: 'right',
  },
}))

const flyOutContent = (
  <>
    <Typography>
      <Box
        sx={{
          fontWeight: 600,
          m: 1,
        }}
      >
        Cloud Marketplace Commerce Management
      </Box>

      <Box
        sx={{
          fontWeight: 'fontWeightRegular',
          m: 1,
        }}
      >
        Flyout is a zero code solution designed to makes it easier and efficient
        for B2B businesses to operate and conquer cloud marketplaces.
      </Box>
      <br />
      <Box
        style={{ display: 'flex' }}
        sx={{
          fontWeight: 'fontWeightRegular',
          m: 1,
        }}
      >
        <CheckCircleOutlineIcon style={{ paddingRight: '10px' }} />
        Fast track your listing on cloud marketplaces
      </Box>
      <Box
        style={{ display: 'flex' }}
        sx={{
          fontWeight: 'fontWeightRegular',
          m: 1,
        }}
      >
        <CheckCircleOutlineIcon style={{ paddingRight: '10px' }} />
        Integrate and manage workflows directly from your CRM.
      </Box>
      <Box
        style={{ display: 'flex' }}
        sx={{
          fontWeight: 'fontWeightRegular',
          m: 1,
        }}
      >
        <CheckCircleOutlineIcon style={{ paddingRight: '10px' }} />
        Manage metering, Private offers, upgrades and renewals.
      </Box>
      <Box
        style={{ display: 'flex' }}
        sx={{
          fontWeight: 'fontWeightRegular',
          m: 1,
        }}
      >
        <CheckCircleOutlineIcon style={{ paddingRight: '10px' }} />
        Track the right metrics and simplify your quote to cash workflow.
      </Box>
    </Typography>
  </>
)

const InactiveFlyoutProductContent = () => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const selectFlyOut = () => navigate('/product-selection?product=flyout')
  const activeProducts = useSelector<string[]>(
    state => state.AccountData.user.partnerData?.activeProducts || []
  )
  const hasOppSync = activeProducts.includes('oppsync')
  const isDisabled = hasOppSync
  return (
    <div className={classes.root} data-testid="flyout-product-content">
      {flyOutContent}
      <div className={classes.button}>
        <Button
          styleType="primary"
          onClick={selectFlyOut}
          data-testid="select-flyout-option"
          disabled={isDisabled}
        >
          Select
        </Button>
      </div>
    </div>
  )
}

export default InactiveFlyoutProductContent
